import React, { FC } from 'react';
import ContentLoader from 'react-content-loader';

interface Props {}

const OpeningHoursTileLoader: FC<Props> = () => {
	return (
		<ContentLoader height={200} width={829} speed={2} backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
			<rect x="0" y="0" rx="0" ry="0" width="200" height="200" />
			<rect x="250" y="0" rx="0" ry="0" width="150" height="15" />
			<rect x="250" y="40" rx="0" ry="0" width="200" height="15" />
			<rect x="250" y="80" rx="0" ry="0" width="100" height="15" />
			<rect x="250" y="120" rx="0" ry="0" width="100" height="15" />
			<rect x="250" y="140" rx="0" ry="0" width="150" height="15" />
			<rect x="250" y="165" rx="0" ry="0" width="150" height="35" />
			<rect x="600" y="0" rx="0" ry="0" width="200" height="200" />
		</ContentLoader>
	);
};

export default OpeningHoursTileLoader;
